import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

const revertToGhDefaultsTheme = createMuiTheme({
  overrides: {
    MuiBackdrop: {
      root: {
        fontFamily: "'Untitled Sans', sans-serif",
        backgroundColor: 'rgba(0,0,0,0.3)',
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 2,
      },
    },
  },
  typography: {
    fontFamily: "'Untitled Sans', sans-serif",
  },
});

export default function DefaultTheme(props) {
  return (
    <ThemeProvider theme={revertToGhDefaultsTheme}>
      {props.children}
    </ThemeProvider>
  );
}
